/**
 * Currency options for booking forms
 */
export const CURRENCY_OPTIONS = [
  { value: 'EUR', label: 'EUR' },
  { value: 'USD', label: 'USD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'CHF', label: 'CHF' },
  { value: 'JPY', label: 'JPY' },
  { value: 'CAD', label: 'CAD' },
  { value: 'AUD', label: 'AUD' },
];

/**
 * Booking type options
 */
export const BOOKING_TYPE_OPTIONS = [
  { value: 'purchaseinvoice', label: 'Purchase Invoice' },
  { value: 'purchasecreditnote', label: 'Purchase Credit Note' },
];
